<ng-container *var="vm$ | async as vm">
  <div class="form-container" *ngFor="let row of vm?.fieldsStructure; trackBy: trackByStructure">
    <!-- Get fields value-->
    <ng-container *var="row.fields as fields">
      <!--render inputs in a template-->
      <div class="d-flex">
        <ng-container
          *ngFor="let rowFieldsEntry of fields; trackBy: trackByFieldSettings; let rowFieldEntryIndex = index"
        >
          <!-- set field as value-->
          <ng-container *var="rowFieldsEntry.field as field">
            <!-- check depends on -->
            <div
              *ngIf="rowFieldsEntry.show$ | async"
              class="grow1 input-field input-field-{{ field.type }}"
              [ngClass]="field['grid-col-width'] ? 'grow' + field['grid-col-width'] : null"
            >
              <orderform-generator-input
                (focused)="onFieldFocused($event)"
                (blurred)="onFieldBlurred($event)"
                [inputId]="
                  field.postname + '-' + uniqueComponentId ||
                  'no-postname-parameter-' + rowFieldEntryIndex + '-' + uniqueComponentId
                "
                [field]="field"
                [formGroupRef]="vm.formGroup"
                (inputFocusToggle)="$event ? setFocusField(field.postname) : removeFocusField(field.postname)"
              ></orderform-generator-input>

              <div *ngIf="field.hint" class="mt-2 text-muted">
                {{ field.hint }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- show messages items seperated from inputs because
       some inputs can be tiny -->
      <div class="d-flex">
        <ng-container *ngFor="let rowFieldsEntry of fields; trackBy: trackByFieldSettings">
          <div class="grow1" *ngIf="rowFieldsEntry.show$ | async">
            <ng-container *var="rowFieldsEntry.field as field">
              <div class="success-message" *ngIf="vm.successMessages[field.postname] as successMessage">
                {{ successMessage }}
              </div>

              <orderform-input-errors
                [fieldName]="field.label !== 'skip' ? field.label : ''"
                [regexMessage]="field.regex_message?.replace('[LABEL]', field.label)"
                [control]="vm.formGroup.controls[field.postname]"
              ></orderform-input-errors>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
